import { useQuery } from 'react-query';
import { useMemo, useState } from 'react';
import ContractsForm from './ContractsForm';
import TopOfPages from '../components/TopOfPages';
import { CONTRACTS_URL } from '../../../data/url/mainUrl';
import { useLocation, useParams } from 'react-router-dom';
import SpinnerLoader from '../../../components/ui/SpinnerLoader';
import { useTranslations } from '../../../data/fetch/fetchAdditionalApi';
import { useProfileApiContext } from '../../../contexts/ProfileApiContext';
import { fetchContacts, fetchContract, fetchContractItemXml } from '../../../data/fetch/fetchMainApi';
import { ActionLinkComponent, InfoTextComponent, XmlTextComponents } from '../../../components/ui/TextComponents';

function ContractItem() {

    // router options

    const path = useLocation();
    const { id, lang } = useParams();

    // API options

    const [contact, setContact] = useState("");

    const dataContract = useQuery(['itm-contract', id], () => fetchContract(id));
    const dataContact = useQuery(['user-contacts', contact], () => fetchContacts(contact));
    const dataTranslations = useTranslations(lang);
    const dataContractXml = useQuery(['contract-item-xml', `${id}?view=true`], () => fetchContractItemXml(`${id}?view=true`));

    useMemo(() => {
        setContact(dataContract?.data?.data?.contract?.contactId);
    }, [dataContract?.isLoading]);

    // useContext hook options

    const { openUniversalFile } = useProfileApiContext();

    return (
        path.search == "?form" ?
            <ContractsForm />
            :
            <div className="ContractItem parent">
                <div className="p-wrapper">
                    <TopOfPages backlink={`/contracts`} contractsearch={true} contractlink={`/contracts`} placeholdercontract={'enter_con_num'} />
                    <div className="mtop-2"></div>
                    {dataContractXml?.isLoading ?
                        <SpinnerLoader />
                        :
                        <div>
                            <XmlTextComponents xmlText={dataContractXml?.data?.data} />
                            <div className="gap-05 mtop-2" style={{ display: "flex", flexDirection: "column" }}>
                                <InfoTextComponent text={"standart_download_contract"} disabled={false} />
                                <ActionLinkComponent action={() => openUniversalFile(`${CONTRACTS_URL}/${id}?pdf`)}><i className="fa fa-download"></i> <b>{dataTranslations?.data?.data["download_the_contract"]}</b></ActionLinkComponent>
                                <ActionLinkComponent action={() => openUniversalFile(`${CONTRACTS_URL}/${id}?pdf&stump=false`)}><i className="fa fa-download"></i> <b>{dataTranslations?.data?.data["pay_2"]}</b></ActionLinkComponent>
                                <ActionLinkComponent action={() => openUniversalFile(`${CONTRACTS_URL}/${id}?pdf&clean=true`)}><i className="fa fa-download"></i> <b>{dataTranslations?.data?.data["pay_3"]}</b></ActionLinkComponent>
                                <ActionLinkComponent action={() => openUniversalFile(`${CONTRACTS_URL}/${id}?pdf&stump=false&clean=true`)}><i className="fa fa-download"></i> <b>{dataTranslations?.data?.data["pay_4"]}</b></ActionLinkComponent>
                                <br />
                                {dataContact?.data?.data?.contact?.organization &&
                                    <InfoTextComponent text={"special_download_contract"} disabled={false} />
                                }
                                {dataContact?.data?.data?.contact?.organization &&
                                    <ActionLinkComponent action={() => openUniversalFile(`${CONTRACTS_URL}/${id}?pdf&template=financial`)}><i className="fa fa-download"></i> <b>{dataTranslations?.data?.data["download_the_contract"]}</b></ActionLinkComponent>
                                }
                                {dataContact?.data?.data?.contact?.organization &&
                                    <ActionLinkComponent action={() => openUniversalFile(`${CONTRACTS_URL}/${id}?pdf&stump=false&template=financial`)}><i className="fa fa-download"></i> <b>{dataTranslations?.data?.data["pay_2"]}</b></ActionLinkComponent>
                                }
                                {dataContact?.data?.data?.contact?.organization &&
                                    <ActionLinkComponent action={() => openUniversalFile(`${CONTRACTS_URL}/${id}?pdf&clean=true&template=financial`)}><i className="fa fa-download"></i> <b>{dataTranslations?.data?.data["pay_3"]}</b></ActionLinkComponent>
                                }
                                {dataContact?.data?.data?.contact?.organization &&
                                    <ActionLinkComponent action={() => openUniversalFile(`${CONTRACTS_URL}/${id}?pdf&stump=false&clean=true&template=financial`)}><i className="fa fa-download"></i> <b>{dataTranslations?.data?.data["pay_4"]}</b></ActionLinkComponent>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
    )
}

export default ContractItem
